<template>
  <v-dialog
    v-model="_active"
    @click:outside="_setActive(false)"
    :width="cardWidth"
  >
    <v-card style="overflow-x: hidden" class="pa-4">
      <div class="d-flex">
        <div style="width:50%; border: solid 1px black;" class="pa-3 ma-2">
          <h2>Rentals Report</h2>
          <v-row
            align="center"
            v-for="(dataPoint, index) in dataPoints"
            :key="index"
          >
            <v-col cols="10" class="py-1">
              <v-card-text class="py-0">
                {{ dataPoint.label }}
              </v-card-text>
            </v-col>
            <v-col cols="2" class="pa-0">
              <v-checkbox
                hide-details
                dense
                v-model="exportObject[dataPoint.value]"
                class="mt-n1"
              />
            </v-col>
          </v-row>
        </div>
        <div
          style="width:50%; border: solid 1px black; height:fit-content;"
          class="pa-3 ma-2"
        >
          <h2>Export Type</h2>
          <v-row align="center">
            <v-col cols="10" class="py-1">
              <v-card-text class="py-0">
                CSV
              </v-card-text>
            </v-col>
            <v-col cols="2" class="pa-0">
              <v-checkbox hide-details dense v-model="csv" class="mt-n1" />
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="10" class="py-1">
              <v-card-text class="py-0">
                Excel Document
              </v-card-text>
            </v-col>
            <v-col cols="2" class="pa-0">
              <v-checkbox hide-details dense v-model="excel" class="mt-n1" />
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="d-flex justify-center align-center flex-column">
        <v-btn
          class="white--text mb-2 mt-3"
          color="secondary"
          @click="exportReport()"
          :width="180"
        >
          <v-icon small>mdi-download</v-icon>
          Export
        </v-btn>
        <v-btn class="mb-3" @click="_setActive(false)" :width="180">
          Cancel
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  mixins: [MobileView],
  data: () => ({
    csv: true,
    excel: false,
    dataPoints: [
      { label: 'Device ID', value: 'id' },
      { label: 'Originating Location', value: 'originatingLocation' },
      { label: 'Destination Location', value: 'destinationLocation' },
      { label: 'RA#', value: 'ra_number' },
      { label: 'Rental Status', value: 'rental_status' },
      { label: 'Return Date', value: 'return_date' },
      { label: 'Device Status', value: 'status' },
      { label: 'Trip Type', value: 'trip_type' },
      { label: 'Notes', value: 'notes' },
    ],
    exportObject: {
      id: true,
      originatingLocation: true,
      destinationLocation: true,
      ra_number: true,
      rental_status: true,
      return_date: true,
      status: true,
      trip_type: true,
      notes: true,
    },
  }),
  methods: {
    ...mapMutations({
      _setActive: 'reconciliation/setDataExport',
      setConfirmation: 'reconciliation/setExportConfirmation',
      setExportData: 'reconciliation/setExportData',
    }),
    exportReport() {
      this._setActive(false);
      this.setConfirmation(true);
      this.setExportData(this.exportObject);
    },
  },
  computed: {
    ...mapGetters({
      _active: 'reconciliation/getDataExport',
    }),
    cardWidth() {
      if (this.showMobileView) {
        return '';
      }
      return '50%';
    },
  },
};
</script>

<style></style>
